"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricInitializer = exports.errorHandler = void 0;
var KatalMetrics = __importStar(require("@amzn/katal-metrics"));
var katal_metrics_driver_sushi_1 = __importDefault(require("@amzn/katal-metrics-driver-sushi"));
var KatalMetricsDriverConsoleLogJson_1 = __importDefault(require("@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson"));
var util_1 = require("../util");
var MetricPublisher_1 = require("./MetricPublisher");
var errorHandler = function (err) { return console.error(err); };
exports.errorHandler = errorHandler;
// Strings for fields “site”, “serviceName”, “methodName”, “metricKey” must match be valid PMET field names:
// maximum length of 256, only letters, numbers, and the dot, colon, at-sign, underscore, forward-slash,
// and slash characters (in short the regex ^[A-Za-z0-9.:@_/-]+$).
var MetricInitializer = /** @class */ (function () {
    function MetricInitializer(domain, realm, website, service, relatedMetricsMappings) {
        var _this = this;
        this.validateInput = function (domain, realm) {
            return (0, util_1.validateRealm)(realm) && (0, util_1.validateDomain)(domain);
        };
        this.buildContext = function () {
            var contextBuilder = new KatalMetrics.Context.Builder()
                .withSite(_this.website)
                .withServiceName("".concat(_this.domain, ":").concat(_this.service));
            if (!_this.relatedMetricsMappings) {
                return contextBuilder.build();
            }
            for (var _i = 0, _a = _this.relatedMetricsMappings; _i < _a.length; _i++) {
                var mapping = _a[_i];
                contextBuilder.addRelatedMetrics(new KatalMetrics.Metric.String(mapping.key, mapping.value));
            }
            return contextBuilder.build();
        };
        this.buildDriver = function () {
            return (0, util_1.isDevEnv)()
                ? new KatalMetricsDriverConsoleLogJson_1.default()
                : new katal_metrics_driver_sushi_1.default.Builder()
                    .withDomainRealm(_this.domain, _this.realm)
                    .withErrorHandler(exports.errorHandler)
                    .build();
        };
        this.initialise = function () {
            var katalPublisher = new KatalMetrics.Publisher(_this.buildDriver(), exports.errorHandler, _this.buildContext());
            return new MetricPublisher_1.MetricPublisher(katalPublisher);
        };
        this.domain = domain;
        this.realm = realm;
        this.website = website;
        this.service = service;
        this.relatedMetricsMappings = relatedMetricsMappings;
        this.validateInput(this.domain, this.realm);
    }
    return MetricInitializer;
}());
exports.MetricInitializer = MetricInitializer;
